import React from "react";
import type { ClarificationStatus } from "../../types/clarification.type";
import {
  CLARIFICATION_STATUS_COLORS,
  CLARIFICATION_STATUS_LABELS,
} from "../../constants/clarification.constants";
import { ClarificationBadge } from "./ClarificationBadge";

interface ClarificationStatusBadgeProps {
  className?: string;
  status: ClarificationStatus;
}

export const ClarificationStatusBadge: React.FC<ClarificationStatusBadgeProps> = ({
  status,
  className = "",
}) => {
  return <ClarificationBadge className={className} colors={CLARIFICATION_STATUS_COLORS} labels={CLARIFICATION_STATUS_LABELS} value={status} />
};
